import { IonCol, IonRow } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import NumPadToggleBox from '../../../../../components/numPadToggleBox/NumPadToggleBox.component'
import { CardioConstants } from '../../store/cardio.constants'
import { hyphenDotKeys } from '../../../../../components/numberPad/NumberPad.types'
import { getInitialAssessmentCardio } from '../../../cardio/selectors/getInitialAssessmentCardio.selectors'
import { saveCardio, setMa, setPmMode, setRate, setType } from '../../store/cardio.actions'
import Validation from '../../../../../components/validation/Validation.component'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { getInitialAssessmentCardioOptionsSelector } from '../../../../options/selectors/getInitialAssessmentCardioOptions.selector'
import { IOption } from '../../../../../common/common.types'
import SInput from '../../../../../components/stringInput/StringInput.component'
import { isPlatformWeb } from '../../../../../utilities'
import NumberPad from '../../../../../components/numberPad/NumberPad.component'

const PacemakerContent: React.FC = () => {
  const { t } = useTranslation()
  const cardioOptions = useSelector(getInitialAssessmentCardioOptionsSelector)
  const { pmTypeOptions } = cardioOptions

  const dispatch = useDispatch()
  const cardioState = useSelector(getInitialAssessmentCardio)
  const { prPm } = cardioState
  const { type, rate, ma, pmMode } = prPm

  const setPacemakerTypeOnChange = (option: IOption) => {
    dispatch(setType(option))
    dispatch(saveCardio())
  }

  const setRateOnChange = (numbers: string[]) => {
    const newRate = numbers.length ? numbers.join('') : null
    dispatch(setRate(newRate))
    dispatch(saveCardio())
  }

  const setMaOnChange = (numbers: string[]) => {
    const newMa = numbers.length ? numbers.join('') : null
    dispatch(setMa(newMa))
    dispatch(saveCardio())
  }

  const setModeOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setPmMode(e.detail.value))
    dispatch(saveCardio())
  }

  return (
    <>
      <IonRow className='mb-1'>
        <IonCol className='ion-no-padding font-roboto picklist'>
          <SingleSelect
            dataTestID='PacemakerType'
            options={pmTypeOptions}
            selectedOption={type}
            listHeader={t('cardio.Type')}
            label={t('cardio.Type')}
            action={setPacemakerTypeOnChange}
          />
        </IonCol>
      </IonRow>
      {isPlatformWeb() ? (
        <>
          <hr className='field-divider' />
          <IonRow className='mb-1'>
            <IonCol className='ion-no-padding font-roboto picklist'>
              <NumberPad
                isPHI
                dataTestId={t('cardio.RateWithUnit')}
                label={t('cardio.RateWithUnit')}
                values={rate ? rate?.split('') : []}
                onNumPadClick={setRateOnChange}
                validCharacters={hyphenDotKeys}
              />
            </IonCol>
          </IonRow>
          <Validation id={CardioConstants.SET_RATE} />
          <hr className='field-divider' />
          <IonRow className='mb-1'>
            <IonCol className='ion-no-padding font-roboto picklist'>
              <NumberPad
                isPHI
                dataTestId={t('cardio.mA')}
                label={t('cardio.mA')}
                values={ma ? ma?.split('') : []}
                onNumPadClick={setMaOnChange}
                validCharacters={hyphenDotKeys}
              />
            </IonCol>
          </IonRow>
          <Validation id={CardioConstants.SET_MA} />
          <hr className='field-divider' />
        </>
      ) : (
        <>
          <IonRow className='gray-bg button-align'>
            <NumPadToggleBox
              numberPadValues={rate ? rate?.split('') : []}
              score={rate}
              action={setRateOnChange}
              label={t('cardio.Rate')}
              unitLabel={'bpm'}
              validCharacters={hyphenDotKeys}
              validationAction={CardioConstants.SET_RATE}
            />
            <NumPadToggleBox
              numberPadValues={ma ? ma?.split('') : []}
              score={ma}
              action={setMaOnChange}
              label={t('cardio.mA')}
              validCharacters={hyphenDotKeys}
              validationAction={CardioConstants.SET_MA}
            />
          </IonRow>
          <Validation id={CardioConstants.SET_RATE} />
          <Validation id={CardioConstants.SET_MA} />
        </>
      )}

      <IonRow className='mt-1'>
        <SInput
          label='Mode'
          color='primary-alt'
          dataTestID='Mode'
          inputValue={pmMode}
          onChangeAction={setModeOnChange}
        />
        <Validation id={CardioConstants.SET_PMMODE} />
      </IonRow>
    </>
  )
}

export default PacemakerContent
